import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Container, IconButton, Icon, Typography } from "@mui/material";
import eye_close_icon from "src/components/UI/Home/Menu/assets/images/eye-close.svg";
import eye_open_icon from "src/components/UI/Home/Menu/assets/images/eye-open.svg";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import styles from "src/components/UI/Home/Menu/assets/scss/Layers.module.scss";
import BasePanel from "src/components/UI/Shared/BasePanel";
import SearchBar from "./Search";
import Store from "src/data/store";
import GraphicsLayer from "esri/layers/GraphicsLayer";
// handlera
import addGraphics from "src/components/UI/Shared/addGraphics";
// interfaces
import { Layer } from "src/store/interfaces";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";

const store = Store.getInstance();

const Layers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activePanel = useSelector((state: any) => state.app.activePanel);
  const mobileMode = useSelector((state: any) => state.app.mobileMode);

  const [isHovered, setIsHovered] = useState(false);
  const [mouseEnter, setMouseEnter] = useState(false);
  const [hiddenLayers, setHiddenLayers] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [matchedLayers, setMatchedLayers] = useState<Layer[]>([]);

  const layersArray = Array.from(store.MapView?.map.layers ?? []);
  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason !== "backdropClick") {
      dispatch(appActions.setActivePanel(undefined));
      navigate("..");
    }
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
    setMouseEnter(false);
  };

  const handleMouseLeave = () => {
    setMouseEnter(true);
  };

  const handleToggleVisible = (layerId: string, title: string) => {
    if (store.MapView && hiddenLayers.includes(layerId)) {
      store.MapView.map.findLayerById(layerId).visible = true;
    } else {
      if (store.MapView) {
        store.MapView.map.findLayerById(layerId).visible = false;
        dispatch(
          appActions.setNotification({
            open: true,
            message: `Layer ${title} is hidden.`,
            severity: "warning",
          })
        );
      }
    }
    setHiddenLayers((prevHiddenLayers) => {
      if (prevHiddenLayers.includes(layerId)) {
        return prevHiddenLayers.filter((id) => id !== layerId);
      } else {
        return [...prevHiddenLayers, layerId];
      }
    });
  };
  const handleRemoveLayer = (id: string, title: string) => {
    if (store.MapView) {
      store.MapView.map.layers.remove(store.MapView.map.findLayerById(id));
      const filteredLayers = layersArray?.filter((layer) => layer.id !== id);
      if (filteredLayers) setMatchedLayers(filteredLayers);
      dispatch(
        appActions.setNotification({
          open: true,
          message: `Layer ${title} is removed.`,
          severity: "success",
        })
      );
    }
  };

  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
    const filteredLayers = layersArray?.filter((layer) =>
      layer.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (filteredLayers) setMatchedLayers(filteredLayers);
  };
  const handleLayerClicked = (id: string) => {
    const layer = store.MapView?.map.findLayerById(id) as GraphicsLayer;
    console.log(layer.graphics.toArray());
    addGraphics.geodesicBuffer_points(layer.graphics.toArray());
  };
  useEffect(() => {
    if (layersArray && activePanel === "layers") setMatchedLayers(layersArray);
  }, [activePanel]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsHovered(false);
      setMouseEnter(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <BasePanel
      openModal={activePanel === "layers"}
      onClose={handleClose}
      panelName="Layers"
      minH="70%"
    >
      <SearchBar onSearch={handleSearch} />
      <Container className={styles.layersContainer}>
        {matchedLayers
          .filter((x) => {
            const layer = x as GraphicsLayer | FeatureLayer | MapImageLayer;
            const type = layer.type;
            if (type === "graphics") return layer.graphics.length > 0;
            else return layer;
          })
          .map((layer) => (
            <Container
              key={layer.id}
              className={styles.layerContainer}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {!mobileMode && isHovered ? (
                <div
                  className={`${styles.line} ${mouseEnter ? styles.fade : ""}`}
                />
              ) : (
                <div className={`${styles.line} `} />
              )}
              <Typography
                className={styles.layerName}
                variant="subtitle2"
                onClick={() => handleLayerClicked(layer.id)}
              >
                {layer.title}
              </Typography>

              <div className={`${styles.icons} `}>
                <IconButton
                  className={`${styles.icon}`}
                  onClick={() => handleToggleVisible(layer.id, layer.title)}
                >
                  <Icon className={`${styles.iconRoot}`}>
                    <img
                      src={
                        hiddenLayers.includes(layer.id)
                          ? eye_close_icon
                          : eye_open_icon
                      }
                    />
                  </Icon>
                </IconButton>
                <IconButton
                  className={styles.icon}
                  onClick={() => handleRemoveLayer(layer.id, layer.title)}
                >
                  <ClearOutlinedIcon />
                </IconButton>
              </div>
            </Container>
          ))}
      </Container>
    </BasePanel>
  );
};

export default Layers;
